import { DOG_AGE_STAGE_OPTIONS } from 'root-constants'
import moreThanFiveYears from '../../assets/images/sprite/moreThanFiveYears.svg'
import oneTwoYears from '../../assets/images/sprite/oneTwoYear.svg'
import twoFiveYears from '../../assets/images/sprite/twoFiveYears.svg'
import zeroSixMonths from '../../assets/images/sprite/zeroSixMonths.svg'
import { TOption } from './types'

export const AGE_OPTIONS: Array<TOption> = [
  {
    value: DOG_AGE_STAGE_OPTIONS.YOUNGER_THEN_ONE_YEAR,
    image: zeroSixMonths,
    translationKey: 'onboarding.age.youngerThenOneYear',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.ONE_TWO_YEAR,
    image: oneTwoYears,
    translationKey: 'onboarding.age.oneTwoYear',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.TWO_SEVEN_YEARS,
    image: twoFiveYears,
    translationKey: 'onboarding.age.twoSevenYears',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.MORE_THAN_SEVEN_YEARS,
    image: moreThanFiveYears,
    translationKey: 'onboarding.age.moreThanSevenYears',
  },
]

export const MOTIVATION_OPTIONS = {
  traingDog: 'Train an Emotional Support Dog',
  getEsaLetter: 'Get an ESA letter',
  learnMore: 'Learn more',
  other: 'Other',
}

export const SIX_MONTHS_OR_YOUNGER = 'six_months_or_younger'
